/* eslint-disable */
import * as handtrack from '@tensorflow-models/handpose'
import WebsocketManager from "@/js/websocketManager.js"

export default class WatchHands{
    constructor(parent) {
        this.parent = parent
        this.vid = null
    }

    setVideo(vid){
        this.vid = vid
    }

    async setTensor() {
        // Load the MediaPipe handpose model assets.
        this.model = await handtrack.load();
        // Pass in a video stream to the model to obtain 
        // a prediction from the MediaPipe graph.
    }

    async hand () {
        if (this.model == undefined || this.vid == null) {
            return
        }
        const hands = await this.model.estimateHands(this.vid);
        // WebsocketManager.sendTrackingData(hands)
        return hands
    }
}